import react from 'react';

export default function Loader() {
    const styles = {
        loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: 'var(--bg)',
  },
  loader: {
    textAlign: 'center',
  },
  spinner: {
    width: '48px',
    height: '48px',
    border: '4px solid var(--border)',
    borderTop: '4px solid var(--primary)',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    margin: '0 auto 16px',
  },
    }
    return (
         <div style={styles.loadingContainer}>
      <div style={styles.loader}>
        <div style={styles.spinner}></div>
        <p>Loading  details...</p>
      </div>
    </div>



    );

    
}